export default {
  VerifyModal: {
    title: "Confirm Your Account",
    send: "Submit for Review",
    step1: {
      reason:
        "This service is designed exclusively for medical professionals, so access to certain features is restricted to verified users only. This ensures:",
      reasons: {
        1: "Excluding access for patients and unauthorized individuals",
        2: "Guaranteeing a professional community for knowledge and experience exchange",
        3: "Maintaining medical ethics and standards for handling data",
      },
      end: "We value your security and privacy. All information is used solely to verify your status and is deleted upon completion of the process.",
      status: "Status",
      statuses: {
        doctor: "Doctor",
        student: "Student",
        ordinator: "Resident",
      },
    },
    step2: {
      agenda:
        "All submitted data is protected and used exclusively to verify your status.",
      chooseVerifyWay: "Choose a Verification Method",
      ways: {
        1: "Diploma, certificate, or license",
        2: "Link to your verified profile on a medical aggregator (ProDoctors, DocDoc, etc.)",
        3: "Link to your profile on a clinic's website",
        4: "Upload a diploma in medical education",
        5: "Upload a student ID from a medical university",
      },
      selectFile: "Select File",
      sendToCheck: "Submit for Review",
      pasteLink: "Paste Link",
      notAllowedFile: "Only PDF and image files are allowed",
      noMoreFiles: "Maximum files allowed - ",
    },
    step3: {
      processing: {
        title: "Document sent for review",
        text1_1:
          "We will review your information, and you will receive a notification via email afterwards.",
        text1_2: "",
        text2: "Verification takes one business day.",
      },
      rejected: {
        title: "Account not verified",
        text1_1:
          "Your submission did not pass verification. Please provide valid data. This is required to gain access to AI-powered study uploading and processing.",
        text1_2: "Try again",
      },
    },
  },
};
